 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name     : 'CruiseSheetDetails',
		submitted: false,
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);

		$('#cruisesheetdetails-bundle').on('change', function bundleClicked() {
			var $self = $(this);

			if ($self.prop('checked')) {
				Adzuki.CustomConfirm({
					body   : 'Are you sure you wish to send the bundled cruise sheets immediately upon form submission? If you choose this option, you will not have an opportunity to view previews of the cruise sheets before emailing.',
					confirm: function yes() {
						$self.prop('checked', true);
						adjustCruiseSheetSubject(true);
					},
					cancel: function no() {
						$self.prop('checked', false);
						adjustCruiseSheetSubject(false);
					}
				});
			}

			adjustCruiseSheetSubject(false);
		});
	});

	form.load = function load()
	{
		var $jForm  = $('form[name="' + form.name + '"]');

		$jForm.submit(function formSubmitted(e) {
			form.submitted = true;
		});

		// if user tries to leave this page, besides via a form submission, throw a warning that their info hasn't been saved
		$(window).on('beforeunload', function before() {
			if (form.submitted === false) {
				return 'Are you sure you want to leave before saving your cruise sheet?';
			}
		});
	};

	form.success = function success(response)
	{
		// validation error, so we need to reset submitted to false so the beforeunload gets fired if the user fails the validation and then tries to click a link
		if (Adzuki.Form.hasError(response)) {
			form.submitted = false;
			return false;
		}

		// default behavior if form successfully submitted with no validation errors
		window.location.href = response['data'];
	};


	// Default subject if the agent does not have a cruise sheet subject in their settings and they are adding multiple cruise sheets.
	// if they are bundling and sending, the subject should be plural though.
	function adjustCruiseSheetSubject(is_checked)
	{
		var $subject_el = $('#cruisesheetdetails-subject'),
			subject     = $subject_el.val();

		if ( (is_checked) && (subject === 'Your Personalized Cruise Sheet') ) {
			$subject_el.val(subject += 's');
		}

		if ( (!is_checked) && (subject === 'Your Personalized Cruise Sheets') ) {
			subject = subject.slice(0, -1);
			$subject_el.val(subject);
		}

	}

}(jQuery, window.Adzuki || {}));
